import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";

const startsWithPath = (pathname, prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`);

const RouteSeoDefaults = () => {
    const location = useLocation();
    const pathname = location.pathname;

    if (pathname === "/") {
        return (
            <Seo
                title="StockMaid - High-Demand Product Tracker & Restock Alerts"
                description="Track high-demand products across Best Buy and Micro Center with fast restock alerts and availability monitoring."
                canonicalPath="/"
            />
        );
    }

    if (pathname === "/stocks") {
        return (
            <Seo
                title="Browse High-Demand Products | StockMaid"
                description="Browse current Best Buy and Micro Center availability for GPUs, Pokemon TCG, and other high-demand products."
                canonicalPath="/stocks"
            />
        );
    }

    if (pathname === "/deals") {
        return (
            <Seo
                title="GPU Deals - Best Buy Price Drops & Discounts | StockMaid"
                description="Find the latest Best Buy GPU price drops. Track RTX 5090, 5080, 5070 deals and save on NVIDIA graphics cards."
                canonicalPath="/deals"
            />
        );
    }

    if (pathname === "/subscription") {
        return (
            <Seo
                title="StockMaid Premium - Product Restock Alerts"
                description="Upgrade to premium for personalized Best Buy stock alerts and advanced tracking controls."
                canonicalPath="/subscription"
            />
        );
    }

    if (pathname === "/privacy") {
        return (
            <Seo
                title="Privacy Policy | StockMaid"
                description="Review how StockMaid collects, uses, and protects your account and tracking data."
                canonicalPath="/privacy"
            />
        );
    }

    if (pathname === "/terms") {
        return (
            <Seo
                title="Terms of Service | StockMaid"
                description="Read StockMaid terms for account usage, subscriptions, and service limitations."
                canonicalPath="/terms"
            />
        );
    }

    if (pathname === "/refund") {
        return (
            <Seo
                title="Refund Policy | StockMaid"
                description="Review StockMaid refund eligibility and subscription cancellation policies."
                canonicalPath="/refund"
            />
        );
    }

    if (
        startsWithPath(pathname, "/profile")
        || startsWithPath(pathname, "/my-tracked-stocks")
        || startsWithPath(pathname, "/admin")
        || startsWithPath(pathname, "/dates")
        || startsWithPath(pathname, "/oauth2/redirect")
    ) {
        return (
            <Seo
                title="Account Page | StockMaid"
                description="Sign in to access account and tracking settings."
                canonicalPath={pathname}
                robots="noindex,nofollow"
            />
        );
    }

    return null;
};

export default RouteSeoDefaults;
